import { CogIcon, Filter, Plus } from 'assets/icons';
import AdminSearchInput from 'components/AdminSearch/AdminSearchInput';
import Button from 'components/button';
import PillTabs from 'components/tabs/PillTabs';
import Tooltip from 'components/tooltips/Tooltips';
import useText from 'hooks/useText';
import { useEffect, useRef } from 'react';

const TABS = [
  ['prospects', 'tabProspects'],
  ['new', 'tabNew'],
  ['old', 'tabOld'],
  ['lost', 'tabLost'],
];

/**
 * The bar over the companies: the tabs (the prospects with their count), the
 * search, the cog that chooses the table's columns (`onCustomize`, from
 * 769 px, where the table shows), the filters and the button that adds a
 * company.
 */
const CompaniesToolbar = ({ tab, prospectCount, query, filterCount, onTab, onQuery, onFilter, onCustomize, onAdd }) => {
  const { text } = useText('companies');
  // The tab picked comes into view when the strip scrolls (on a phone).
  const strip = useRef(null);
  useEffect(() => {
    strip.current?.querySelector('[aria-selected="true"]')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  }, [tab]);
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-4 px-4 py-3 lg:px-8">
      {/* On a phone the four tabs scroll sideways instead of leaving the screen. */}
      <div ref={strip} className="no-scrollbar max-w-full overflow-x-auto">
        <PillTabs
          activeTab={tab}
          onChange={onTab}
          tabs={TABS.map(([id, label]) => ({ id, label: text(label), count: id === 'prospects' ? prospectCount : undefined }))}
        />
      </div>
      <span className="flex-1" />
      <div className="w-full tab:w-[260px]">
        <AdminSearchInput value={query} placeholder={text('search')} onChange={(event) => onQuery(event.target.value)} />
      </div>
      {/* The buttons on the right sit closer together than the bar's parts. */}
      <div className="flex items-center gap-2">
        {onCustomize && (
          <span className="hidden tab:inline-flex">
            <Tooltip text={text('customizeColumns')} placement="bottom">
              <Button size="ICON" color="SECONDARY" aria-label={text('customizeColumns')} onClick={onCustomize}>
                <CogIcon wh={20} color="#374151" />
              </Button>
            </Tooltip>
          </span>
        )}
        <Button color="SECONDARY" size="SM" className="shrink-0" onClick={onFilter}>
          <Filter wh={16} color="#374151" />
          <span>
            {text('filter')}
            {filterCount > 0 ? ` (${filterCount})` : ''}
          </span>
        </Button>
        <Button color="PRIMARY" size="SM" className="h-10 shrink-0" onClick={onAdd}>
          <Plus wh={18} color="currentColor" />
          <span>{text('add')}</span>
        </Button>
      </div>
    </div>
  );
};

export default CompaniesToolbar;
